import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'footer.staticPages.tos': {
    id: 'footer.staticPages.tos',
    defaultMessage: 'Terms of Use',
    description: 'The text for the TOS link title in the footer.',
  },
  'footer.staticPages.privacy': {
    id: 'footer.staticPages.privacy',
    defaultMessage: 'Privacy Policy',
    description: 'The text for the privacy policy link title in the footer.',
  },
  'footer.staticPages.help': {
    id: 'footer.staticPages.help',
    defaultMessage: 'Help',
    description: 'The text for the help link title in the footer.',
  },
  'footer.storeAppStore': {
    id: 'footer.storeAppStore',
    defaultMessage: 'Download from App Store',
    description: 'The text for the Download from App Store button.',
  },
  'footer.storeGoogleStore': {
    id: 'footer.storeGoogleStore',
    defaultMessage: 'Download from Google play',
    description: 'The text for the Download from Google play button.',
  },
});

export default messages;
